/**
 * localStorage-backed dev feature flags. Allows toggling features in deployed
 * environments (staging/production) without redeploying, by setting the
 * corresponding localStorage key to the string `'true'`.
 *
 * Related: `debug:<namespace>` keys are used to enable namespaced debug logging.
 * See `packages/ui/src/utils/debug.ts`.
 */

/**
 * Enables the WP Site Control UI at URLs other than the production one.
 */
export function isLocalStorageWpSiteControlEnabled(): boolean {
  return window.localStorage.getItem('wpSiteControlEnabled') === 'true';
}

/**
 * Enables the TanStack devtools (Query and Router panels).
 */
export function isLocalStorageDevtoolsEnabled(): boolean {
  return window.localStorage.getItem('devtoolsEnabled') === 'true';
}
